
import React, { useEffect } from 'react'

/**
 * useEscape hook.
 */

export default function useEscape(cb) {
  function keydown(e) {
    if (e.key == 'Escape') {
      cb()
    }
  }

  useEffect(_ => {
    document.addEventListener('keydown', keydown)
    return _ => {
      document.removeEventListener('keydown', keydown)
    }
  }, [])
}